import { cn } from "@/utils/cn";
import { memo } from "react";

interface DividerProps {
  className?: string;
}

export const Divider = memo(function Divider({ className }: DividerProps) {
  return <hr className={cn("h-[1px] w-full text-[#D9D9D9]", className)} />;
});
